import { render, staticRenderFns } from "./SavedArtworks.vue?vue&type=template&id=229c7018&scoped=true"
import script from "./SavedArtworks.vue?vue&type=script&lang=js"
export * from "./SavedArtworks.vue?vue&type=script&lang=js"
import style0 from "./SavedArtworks.vue?vue&type=style&index=0&id=229c7018&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "229c7018",
  null
  
)

export default component.exports